<template>
  <div>
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      title=" Select counterType"
      ref="counterTypeSettingModal"
      id="counterTypeSettingModal"
      size="sm"
      @shown="onModalShown"
    >
      <div class="row settings-box">
        <div class="col-12 py-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container w-100">
              <label :class="selectedCounterType ? 'shift-up' : ''">
                counterType Type
              </label>
              <multiselect
                v-model="selectedCounterType"
                :options="counterTypeOptions"
                label="counter_type"
                track-by="fct_id"
                :searchable="false"
                :multiple="false"
                :allow-empty="false"
                placeholder="."
              ></multiselect>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 pt-3 text-center">
          <button
            class="btn-blue"
            :disabled="!selectedCounterType || isSaving"
            @click="saveWorkstation"
          >
            Save
          </button>
          <button
            @click.prevent.stop="$bvModal.hide('counterTypeSettingModal')"
            class="btn-blue"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PosService from "@/services/PosService";

export default {
  data() {
    return {
      isSaving: false,
      selectedCounterType: null,
      counterTypeOptions: []
    };
  },
  mounted() {
    this.loadCounterTypes();
  },
  methods: {
    setCounterTypeCookie(counterType) {
      if (typeof document === "undefined") return;
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);

      // Save name and id as separate cookies
      document.cookie = `counter_type=${encodeURIComponent(counterType.counter_type)}; expires=${expires.toUTCString()}; path=/`;
      document.cookie = `counter_type_id=${encodeURIComponent(counterType.fct_id)}; expires=${expires.toUTCString()}; path=/`;
    },
    async onModalShown() {
      await this.loadCounterTypes();
    },
    async loadCounterTypes() {
      try {
        const response = await PosService.getAllCounterTypes();
        console.log("Response", response);
        const counterTypes = response.data.Records;
        console.log("counterTypes", counterTypes);

        this.counterTypeOptions = counterTypes.map((item) => {
          if (item && typeof item === "object") {
            return {
              fct_id: item.fct_id || item.counter_type_id || item.id,
              counter_type:
                item.counter_name ||
                item.counter_type_name ||
                item.counter_type_code ||
                item.counter_type ||
                item.name ||
                item.value ||
                item.label ||
                item.counterType ||
                item.counterName ||
                ""
            };
          }
          // fallback if API ever returns plain strings
          return { fct_id: null, counter_type: item };
        }).filter(opt => opt.counter_type);

        if (!this.counterTypeOptions.length) {
          this.selectedCounterType = null;
        }
      } catch (error) {
        console.log("Unable to load counter types", error);
      }
    },
    async saveWorkstation() {
      if (!this.selectedCounterType) {
        this.$toasted.show("Please select counterType.");
        return;
      }

      try {
        this.isSaving = true;
        this.setCounterTypeCookie(this.selectedCounterType);

        this.$toasted.show("counterType saved successfully.");
        this.$bvModal.hide("counterTypeSettingModal");
      } catch (error) {
        console.log("Unable to save counterType", error);
        this.$toasted.show("Unable to save counterType.");
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style>
.settings-box {
  font-size: 12px;
  font-weight: bold;
}

#workStationSettingModal___BV_modal_content_ {
  width: 135% !important;
  margin: auto;
}
#workStationSettingModal___BV_modal_title_ {
  width: 100%;
  text-align: center;
  color: var(--blue);
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/CounterTypePopup.vue